const RodSkeleton = () => {
  return (
    <>
      <div className="absolute bottom-0 h-[7.5%] w-[90%] rounded-md bg-gray-800"></div>
      <div className="absolute bottom-0 h-full w-[5%] rounded-t-md bg-gray-800"></div>
    </>
  );
};

export default RodSkeleton;
